const getters = {
  menus: state => state.menu.menus
}
export default getters
